'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * PostCard — an IG-post-style card layout.
 *
 * Structure:
 * - Header (avatar + name + meta)
 * - Media area (image/placeholder)
 * - Optional engagement row
 * - Body/caption area
 *
 * This is a presentational shell. Compose it with domain-specific content.
 */

export interface PostCardProps {
  /** Card width class. Defaults to "w-[320px] sm:w-[340px]" */
  widthClass?: string;
  /** Header content (brand avatar + name + source badge) */
  header?: ReactNode;
  /** Media/image area content */
  media: ReactNode;
  /** Optional engagement row (like/comment/share icons) */
  engagement?: ReactNode;
  /** Body/caption content below the media */
  body: ReactNode;
  /** Additional className for the card root */
  className?: string;
}
export function PostCard(t0) {
  const $ = _c(17);
  const {
    widthClass: t1,
    header,
    media,
    engagement,
    body,
    className
  } = t0;
  const widthClass = t1 === undefined ? "w-[320px] sm:w-[340px]" : t1;
  let t2;
  if ($[0] !== className || $[1] !== widthClass) {
    t2 = cn("group flex shrink-0 flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm transition-shadow hover:shadow-md", widthClass, className);
    $[0] = className;
    $[1] = widthClass;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== header) {
    t3 = header && <div className="flex items-center gap-2.5 px-3.5 py-2.5">{header}</div>;
    $[3] = header;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== media) {
    t4 = <div className="relative aspect-square w-full overflow-hidden bg-gradient-to-br from-gray-50 to-gray-100">{media}</div>;
    $[5] = media;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== engagement) {
    t5 = engagement && <div className="flex items-center gap-3 px-3.5 py-2">{engagement}</div>;
    $[7] = engagement;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== body) {
    t6 = <div className="flex flex-1 flex-col px-4 pb-4 pt-2">{body}</div>;
    $[9] = body;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t2 || $[12] !== t3 || $[13] !== t4 || $[14] !== t5 || $[15] !== t6) {
    t7 = <article className={t2}>{t3}{t4}{t5}{t6}</article>;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
}